<template>
  <div>
     <div>
   <el-breadcrumb separator-class="el-icon-arrow-right">
   <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
   <el-breadcrumb-item>导航栏管理</el-breadcrumb-item>
   <el-breadcrumb-item>新增导航栏页面</el-breadcrumb-item>
 </el-breadcrumb>
 </div>
 <el-card style="text-align: center;">
   <el-button type="primary" @click="addInfo(true)">添加二级导航栏</el-button>
       <el-table
     :data="infolist"
     border
     style="width: 100%">
     <el-table-column
       prop="info_CLASS_ID"
       label="ID"
       width="100">
     </el-table-column>
     <el-table-column
       prop="info_CLASS_NAME"
       label="名字"
       width="130">
     </el-table-column>
     <el-table-column
       width="180"
       prop="craeate_DATA"
       label="创建时间">
     </el-table-column>
         <el-table-column
       width="180"
       prop="htmlPath"
       show-overflow-tooltip
       label="html状态">
     </el-table-column>
     <el-table-column
       label="操作"
       width="250">
         <template slot-scope="scope" >
 <el-button  @click="deleteInfoClassByID(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
 <!-- <el-button  icon="el-icon-aim" size="small" @click="showExcelByHeadId(scope.row)"></el-button> -->
 <el-button  @click="inserHtml(scope.row)"  v-show="scope.row.isMenus&&scope.row.router!='InfoFour'"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tianjia"></use></svg></el-button>
 <el-button  @click="updateNavigation(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
       </template>
     </el-table-column>
   </el-table>
 </el-card>
 
 
 <el-dialog
   title="二级导航添加"
   :visible.sync="showAddNavigation"
   width="50%"
   center>
 
   <el-form :model="addForm" ref="addForms" :rules="addInfoRules" label-width="200px" class="demo-dynamic">
     <el-form-item label="名称：" prop="INFO_CLASS_NAME">
     <el-input  v-model="addForm.INFO_CLASS_NAME"></el-input>
   </el-form-item>
   <el-form-item label="上级菜单" prop="INFO_ID">
   <el-select placeholder="请选择上级菜单" v-model="addForm.INFO_ID">
       <el-option :label="info.info_NAME" :value="info.info_ID" v-for="(info,index) in infoEasyList" :key="index"></el-option>
     </el-select>
 </el-form-item>
 
 <el-form-item label="是否包含三级菜单：" prop="isMenus" label-width="200px">
     <el-radio-group v-model="addForm.isMenus">
       <el-radio  label="0">是</el-radio>
       <el-radio  label="1">否</el-radio>
     </el-radio-group>
   </el-form-item>
   <el-form-item label="是否在二级菜单直接显示：" prop="isCommon" v-if="addForm.isMenus!='0'" label-width="200px">
     <el-radio-group v-model="addForm.isCommon">
       <el-radio  label="1">是</el-radio>
       <el-radio  label="0">否</el-radio>
     </el-radio-group>
   </el-form-item>
     <el-form-item label="样式类型：" prop="menusType" v-if="addForm.isMenus==0||addForm.isCommon==1">
     <el-input  type="number" v-model="addForm.menusType"></el-input>
   </el-form-item>
 </el-form>
 <div style="text-align: center;">
     <el-button type="primary" @click="submitAddForm()">提交</el-button>
     <el-button @click="showAddNavigation = false">取 消</el-button>
   </div>
   
   </el-dialog>
 
 
 <el-dialog
   title="导航栏页面添加"
   :visible.sync="showInsertHtml"
   width="50%">
 <el-row>
   <el-col :span="12"><div class="grid-content bg-purple">
 <el-upload
   class="upload-demo"
   drag
   action="https://jsonplaceholder.typicode.com/posts/"
   :auto-upload="false"
   :on-change="fileChange"
   :limit="1"
    ref="uploads"
   :on-remove="fileRemove"
   accept=".html,.htm">
   <i class="el-icon-upload"></i>
   <div class="el-upload__text">将html文件拖到此处，或<em>点击上传</em></div>
 </el-upload>
   </div></el-col>
   <el-col :span="12"><div class="grid-content bg-purple-light">
 
 <el-upload
   class="upload-demo"
   drag
   ref="upload"
   action="https://jsonplaceholder.typicode.com/posts/"
   :auto-upload="false"
   multiple="multiple"
   :show-file-list="false"
   :on-change="handleChanges"
   :on-remove="handleRemoves">
   <i class="el-icon-upload"></i>
   <div class="el-upload__text">将文件样式文件拖到此处，或<em>点击上传</em></div>
    <div class="el-upload__tip" slot="tip">累计上传{{fileList5.length}}个文件</div>
 </el-upload>
   </div></el-col>
 </el-row>
 
 <div class="block">
 </div>
   <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="resetResult">重 置</el-button>
     <el-button @click="showInsertHtml = false">取 消</el-button>
     <el-button type="primary" @click="subInsertHtml">提 交</el-button>
   </span>
 </el-dialog>
 
 <el-dialog
   title="二级导航栏修改"
   :visible.sync="updataTwoNav"
   width="50%"
   center>
   <el-form :model="updateForm" ref="updateForms" :rules="addInfoRules" label-width="200px" >
     <el-form-item label="名称：" prop="INFO_CLASS_NAME">
     <el-input  v-model="updateForm.INFO_CLASS_NAME"></el-input>
   </el-form-item>
   <el-form-item label="上级菜单" prop="INFO_ID">
   <el-select placeholder="请选择上级菜单" v-model="updateForm.INFO_ID">
       <el-option :label="info.info_NAME" :value="info.info_ID" v-for="(info,index) in infoEasyList" :key="index"></el-option>
     </el-select>
 </el-form-item>
 <el-form-item label="是否包含三级菜单：" prop="isMenus" label-width="200px">
     <el-radio-group v-model="updateForm.isMenus">
       <el-radio  label="0">是</el-radio>
       <el-radio  label="1">否</el-radio>
     </el-radio-group>
   </el-form-item>
   <el-form-item label="是否在二级菜单直接显示：" v-show="updateForm.isMenus!='0'" prop="isCommon" label-width="200px">
     <el-radio-group v-model="updateForm.isCommon">
       <el-radio  label="1">是</el-radio>
       <el-radio  label="0">否</el-radio>
     </el-radio-group>
   </el-form-item>
   <el-form-item label="当前顺序：" prop="infoClassOrder">
     <el-input  v-model="updateForm.infoClassOrder" type="number" oninput="if(value.length>5)value=value.slice(0,5)"></el-input>
   </el-form-item>
 
     <el-form-item label="样式类型：" prop="menusType" v-if="updateForm.isMenus==0||updateForm.isCommon==1">
     <el-input  type="number" v-model="updateForm.menusType"></el-input>
   </el-form-item>
 </el-form>
 <span slot="footer" class="dialog-footer">
     <el-button type="primary" @click="submitUpdateForm()">提交</el-button>
     <el-button @click="updataTwoNav = false">取 消</el-button>
   </span>
 


 
 </el-dialog>
  </div>
 </template>
 
 <script>
 export default {
 created(){
     this.getInfo()
 },
 data(){
     return{
        infolist:[],
        infoEasyList:[],
        showInsertHtml:false,
        showAddNavigation:false,
        updataTwoNav:false,
        insertid:'',
        fileList5: [],
        fileList6:[],
        fileList3:[],
        fileList4:[],
        addForm:{
         INFO_CLASS_NAME:'',
         isMenus:'1',
         INFO_ID:'',
         menusType:'',
         isCommon:'0'
        },
        updateForm:{
          isCommon:'',
         INFO_CLASS_NAME:'',
         isMenus:'1',
         INFO_ID:'',
         menusType:'1',
         info_CLASS_ID:'',
         infoClassOrder:'',
        },
        addInfoRules:{
         INFO_CLASS_NAME: [
             { required: true, message: '请输入名称', trigger: 'blur' },
             { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
           ],
           INFO_ID:[
           { required: true, message: '请选择上次菜单', trigger: 'change' },
           ],
           menusType:[
           { required: true, message: '样式类型', trigger: 'blur' },
           ],
           infoClassOrder:[
           { required: true, message: '请填入二级菜单排列顺序', trigger: 'change' },
           ],
           },
 
     }
 },
 methods:{
 getInfo(){
      this.axios.post("/info/getInfoClass")
     .then(resp => { 
                       if(resp.data.status == 1) {                                                       
                                     this.infolist=resp.data.result;
                                      console.log(resp.data.result)                               
                                 }else {
                                    alert("拿取数据失败")                                 
                                 }
                             })
                             .catch((err) => {
                              alert("出错了")
                             })   
                            
 },
 inserHtml(data){
         this.insertid=data.info_CLASS_ID
           this.showInsertHtml=true;
       },handleChanges(file, fileList) {
       this.fileList5=fileList
       },handleRemoves(file, fileList) {
         this.fileList5=fileList
       },fileChange(file, fileList){
         this.fileList3=fileList
       },fileRemove(file, fileList){
         this.fileList3=fileList
       },         subInsertHtml(){
          if(this.fileList5.length <= 0 ||this.fileList3.length==0 ){
            this.$message.error("请选择上传文件") 
          return false}
 
 
 
     for(var i=0;i<this.fileList5.length;i++){
      this.fileList6.push(this.fileList5[i].raw)
     }
     this.fileList4=this.fileList3[0].raw
      let config = {
         headers: { "Content-Type": "multipart/form-data" }
       };
       const fd = new FormData();
     // fd.append("style",this.fileLists)
      
        this.fileList6.forEach((file) => {
          fd.append("style", file);
       });
       fd.append("infoLClassID",this.insertid)
       fd.append("file",this.fileList4)
         this.axios.post("/info/insertHtml",fd,config)
          .then(resp => { 
                        if(resp.data.status == 1) {
                                   this.$message.success("添加成功")
                                   this.fileList5=[]
                                   this.fileList6=[]
                                   this.fileList3=[]
                                   this.fileList4=[]
                                   this.$refs.upload.clearFiles()
                                   this.$refs.uploads.clearFiles()
                                    this.showInsertHtml=false    
                                 }else {
                                   this.$message.error(resp.data.message)
                   
                                   this.fileList6=[],
                                   this.fileList4=[],
                                        alert("出错")                          
                                 }
                             })
                             .catch((err) => {
                                 alert("出错了")
                                 console.log(err)
                             }) 
   
       },resetResult(){
          this.fileList5=[]
                                   this.fileList6=[]
                                   this.fileList3=[]
                                   this.fileList4=[]
                                   this.$refs.upload.clearFiles()
                                   this.$refs.uploads.clearFiles()
       },submitUpdateForm(){
         this.$refs.updateForms.validate(resp=>{
           if(!resp)
           return
           let configs = {
           headers: { "Content-Type" : "application/json" }};    
         const formData = new FormData()
         if(this.updateForm.isMenus==0){this.updateForm.isCommon=0}
       formData.append("INFO_CLASS_NAME",this.updateForm.INFO_CLASS_NAME)
       formData.append('isMenus', this.updateForm.isMenus)
       formData.append('INFO_ID',this.updateForm.INFO_ID)
       formData.append('INFO_CLASS_ID',this.updateForm.info_CLASS_ID)
       formData.append('infoClassOrder',this.updateForm.infoClassOrder)
       formData.append('isCommon',this.updateForm.isCommon)
       if(this.updateForm.menusType!=null){
         formData.append('menusType',this.updateForm.menusType)
       }
         this.axios.post("/info/updateInfoClass",formData,configs)
                 .then(resp => { 
                       if(resp.data.status == 1) {
                         console.log(resp.data)                                                       
                                   this.$message.success("修改成功")  
                                   this.updataTwoNav=false   
                                   this.$refs.updateForms.resetFields()
                                   this.getInfo()
                                 }else {
                                   this.$message.error(resp.data.result.message)                                                      
                                 }
                             })
                             .catch((err) => {
                              alert("出错了")
                             })        })
 
       },
       addInfo(data){
         this.showAddNavigation=data
         this.axios.post("/info/getEasyInfo")
                 .then(resp => { 
                       if(resp.data.status == 1) {                                                       
                                     this.infoEasyList=resp.data.result;
                                      console.log(resp.data.result)                               
                                 }else {
                                    alert("拿取数据失败")                                 
                                 }
                             })
                             .catch((err) => {
                              alert("出错了")
                             })       
       },updateNavigation(data){
        this.updataTwoNav=true
        this.addInfo(false)
        if(data.isMenus){
         var isMenus=1+''
        }else{var isMenus=0+''}
        this.updateForm.isMenus=isMenus
       console.log(data)
        this.updateForm.INFO_CLASS_NAME=data.info_CLASS_NAME
        this.updateForm.infoClassOrder=data.infoClassOrder
        this.updateForm.INFO_ID=data.info_ID
        this.updateForm.menusType=data.menusType
        this.updateForm.info_CLASS_ID=data.info_CLASS_ID
        console.log(data)
       },submitAddForm(){
         this.$refs.addForms.validate(resp=>{
           if(!resp)
           return
           let configs = {
           headers: { "Content-Type" : "application/json" }};    
         const formData = new FormData()
         if(this.addForm.isMenus==0){this.addForm.isCommon=0}
       formData.append("INFO_CLASS_NAME",this.addForm.INFO_CLASS_NAME)
       formData.append('isMenus', this.addForm.isMenus)
       formData.append('INFO_ID',this.addForm.INFO_ID)
       formData.append('isCommon',this.addForm.isCommon)
       if(this.addForm.menusType!=''){
         formData.append('menusType',this.addForm.menusType)
       }
         this.axios.post("/info/insertInfoClass",formData,configs)
                 .then(resp => { 
                       if(resp.data.status == 1) {
                         console.log(resp.data)                                                       
                                   this.$message.success("添加成功")  
                                   this.showAddNavigation=false   
                                   this.$refs.addForms.resetFields()
                                   this.getInfo()
                                 }else {
                                   this.$message.error(resp.data.result.message)                                                      
                                 }
                             })
                             .catch((err) => {
                              alert("出错了")
                             })        })
        
       },deleteInfoClassByID(data){
         const that=this
         this.$confirm("确定删除？","提示",{
           confirmButtonText: "确认",//确认按钮文字更换
           cancelButtonText: "取消",//取消按钮文字更换
           showClose: true,//是否显示右上角关闭按钮
           type: "warning",//提示类型  success/info/warning/error
       }).then(function(){  
         that.axios.post("/info/deleteInfoClassByID?INFO_CLASS_ID="+data.info_CLASS_ID)
         .then(resp => { 
                       if(resp.data.status == 1) {                        
                         that.$message.success("删除成功")  
                         that.getInfo()
                                 }else {
                                   that.$message.error(resp.data.result.message)                                                      
                                 }
                             })
                             .catch((err) => {
                              alert("出错了")
                             })        
       }).catch(()=>{});
       }
 }
 }
 </script>
 
 <style >
 .icon {
   width: 1em;
   height: 1em;
   vertical-align: -0.15em;
   fill: currentColor;
   overflow: hidden;
 }
 

 </style>


// WEBPACK FOOTER //
// src/components/work/bam/navigation.vue